import { render, staticRenderFns } from "./Matriz3.vue?vue&type=template&id=2e35c2c1&"
import script from "./Matriz3.vue?vue&type=script&lang=js&"
export * from "./Matriz3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports